import * as graphql from '@treams/treams-network';

import { SharedFields } from '../ProductConfiguration';
import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function translate(key: string): { title: string; description: string } | undefined {
	if (key === 'clientID') {
		return {
			title: 'API Key',
			description: 'Vul de API key in die je van Visma hebt ontvangen.',
		};
	}

	if (key === 'clientSecret') {
		return {
			title: 'API Secret',
			description: 'Vul de API secret in die je van Visma hebt ontvangen.',
		};
	}

	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

export default function YouServe() {
	return (
		<ProductLayout
			id="youserve"
			type={graphql.ConnectorType.Youserve}
			headerImageURL="https://assets.ontreams.com/marketplace/youserve-wide.jpg"
			translate={translate}
		/>
	);
}

export function YouServeTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="youserve"
			title="YouServe"
			description="Maak je HR-journey optimaal en digitaal."
			logoImageURL="https://assets.ontreams.com/marketplace/youserve.png"
			selected={props.selected}
		/>
	);
}
